import { useSearchParams } from "react-router-dom";

export function useAlert() {
	const [type] = useSearchParams();

	return {
		type: type?.get("type")
	};
}
